export const initialState = {
  isLoading: true,
  isAuthenticated: false,
};
